import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { ConstructibleAfterOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const ConstructibleAfter: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='constructible-after'
        name='constructibleAfter'
        label='wizard.screen.otherFacilities.constructibleAfter'
        value={insertionData.constructibleAfter}
        noInformation={ConstructibleAfterOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.constructibleAfterOptions',
          options: Object.keys(ConstructibleAfterOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'constructibleAfter' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default ConstructibleAfter
